
import { defineComponent } from 'vue'
import ImgPlaceholder from './img-placeholder.vue'
import type { Variants } from './constants'
import type { PropType } from 'vue'

export default defineComponent({
  name: 'MsSkeletonItem',
  components: {
    [ImgPlaceholder.name]: ImgPlaceholder
  },
  props: {
    variant: {
      type: String as PropType<Variants>,
      default: 'text'
    },

    height: {
      type: String,
      default: '13px'
    }
  }
})
